/**
 * Lane C0-PROPS: sounds of the plains kit's interactive props (render/kit/props.ts): a chest opening, a bucket drawn
 * from the well, a training dummy struck (wood or straw), a brazier's crackle and a banner flapping. Procedural; not
 * routed yet (sfx/events.ts is main's: the props have no interaction events today; see the lane report).
 */
import { registerSfx } from '../registry';
import { woodblock } from '../voices';

registerSfx('world.chest.open', { label: 'เปิดหีบ', cat: 'world', vary: 0.04, gap: 0.3 }, (k) => {
  // The latch clicks, the hinges creak, the lid knocks back, a little gold shimmer.
  k.click({ f: 2400, vol: 0.25 });
  k.noise({ at: 0.04, dur: 0.32, vol: 0.12, attack: 0.03, type: 'bandpass', f: 900, f1: 1500, q: 9 });
  k.thump({ f0: 180, f1: 90, at: 0.36, dur: 0.12, vol: 0.28 });
  k.metal({ f: 2600, at: 0.42, dur: 0.6, vol: 0.05 });
  k.metal({ f: 3300, at: 0.5, dur: 0.5, vol: 0.04 });
});

registerSfx('world.well.draw', { label: 'ตักน้ำจากบ่อ', cat: 'world', vary: 0.05, gap: 0.6 }, (k) => {
  // The windlass ticks, the rope runs, water sloshes in the bucket as it comes up.
  for (let i = 0; i < 4; i++) woodblock(k, { f: 820 - i * 30, at: i * 0.12, vol: 0.08 });
  k.noise({ dur: 0.5, vol: 0.06, attack: 0.05, type: 'bandpass', f: 1800, q: 2 });
  k.noise({ at: 0.45, dur: 0.35, vol: 0.14, attack: 0.02, type: 'lowpass', f: 1200, f1: 500 });
  k.tone({ f: 420, f1: 260, at: 0.5, dur: 0.12, vol: 0.05, type: 'sine' });
});

registerSfx('world.dummy.wood', { label: 'ตีหุ่นไม้', cat: 'world', vary: 0.06, gap: 0.05 }, (k, o) => {
  const v = Math.min(1.3, o.intensity ?? 1);
  woodblock(k, { f: 560, vol: 0.3 * v });
  k.thump({ f0: 150, f1: 70, dur: 0.12, vol: 0.25 * v });
});

registerSfx('world.dummy.straw', { label: 'ตีหุ่นฟาง', cat: 'world', vary: 0.08, gap: 0.05 }, (k, o) => {
  const v = Math.min(1.3, o.intensity ?? 1);
  k.thump({ f0: 120, f1: 60, dur: 0.1, vol: 0.28 * v });
  k.noise({ dur: 0.14, vol: 0.18 * v, attack: 0.002, type: 'bandpass', f: 2600, q: 0.8 });
});

registerSfx('world.brazier', { label: 'ไฟในกระถางไฟ', cat: 'ambient', vary: 0.1, gap: 0.2 }, (k) => {
  // A low roar and a few pops.
  k.noise({ dur: 1.2, vol: 0.05, attack: 0.2, type: 'lowpass', f: 500 });
  for (let i = 0; i < 4; i++) k.click({ f: 1800 + k.range(0, 1600), at: k.range(0, 1.1), vol: 0.06 });
});

registerSfx('world.banner.flap', { label: 'ธงสะบัด', cat: 'ambient', vary: 0.1, gap: 0.4 }, (k) => {
  for (let i = 0; i < 3; i++) k.noise({ at: i * 0.16 + k.range(0, 0.05), dur: 0.1, vol: 0.07, attack: 0.01, type: 'bandpass', f: 700 + i * 120, q: 1.4 });
});
